import React from 'react';
import { bandPosition } from './productSignals';

// Competitive micro band: marker = my price within [min,max]
export default function PriceBand({ price, min, max }) {
  if (price == null || price <= 0 || min == null || max == null) return null;
  const frac = bandPosition(price, min, max);
  return (
    <div className="pux-band" title={`${min} - ${max}`}>
      <div className="pux-band-marker" style={{ left: `${frac * 100}%` }} />
    </div>
  );
}
